import {GenericDialogButton} from '@/types/types';
import {ModalTheme} from '@/types/enums/ModalTheme';

export default class ModalOptions<T extends string | number | symbol | undefined = undefined> {
    public title: string = '';
    public question: string = '';
    public buttons: GenericDialogButton<T>[] = [];
    public defaultValue?: T;
    public theme: ModalTheme = ModalTheme.Normal;
    public show: boolean = false;
    public resolve: (result: T) => void = (): void => {
        return;
    };

    public closeModal(result: T): void {
        this.resolve(result);
        this.show = false;
    }
}
